<div class="disclosure-grants">
  <button type="button" class="disclosure-grants__back" (click)="goBack()">
    <img src="/public/svgs/arrow-left-g.svg" alt="" width="16" height="16" aria-hidden="true" />
    {{ 'app.identity.disclosure.grants.back' | translate }}
  </button>

  <header class="disclosure-grants__header">
    <div class="disclosure-grants__header-icon" aria-hidden="true">
      <img src="/public/svgs/globe.svg" alt="" width="22" height="22" />
    </div>
    <div class="disclosure-grants__header-copy">
      <h1 class="disclosure-grants__title">
        {{ 'app.identity.disclosure.grants.pageTitle' | translate }}
      </h1>
      <p class="disclosure-grants__subtitle">
        {{ 'app.identity.disclosure.grants.pageSubtitle' | translate }}
      </p>
    </div>
  </header>

  @if (pageError()) {
    <app-info-banner
      class="disclosure-grants__error"
      [title]="'app.identity.disclosure.page.actionErrorTitle'"
      [message]="pageError()!"
      [ariaLabel]="'app.identity.disclosure.page.actionErrorAria'"
      [translateTitle]="true"
      [translateMessage]="false"
      [translateAriaLabel]="true"
    />
  }

  @if (isLoading()) {
    <div class="disclosure-grants__loading" aria-busy="true">
      <p>{{ 'app.identity.disclosure.grants.loading' | translate }}</p>
    </div>
  } @else if (showLoadError()) {
    <app-parent-empty-state
      [centered]="false"
      titleKey="app.identity.disclosure.grants.error"
      subtitleKey="app.identity.disclosure.page.errorHint"
      ariaLabelKey="app.identity.disclosure.grants.errorAria"
      iconMask="/public/svgs/refresh.svg"
    >
      <app-parent-button parentEmptyActions variant="ghost" (clicked)="refresh()">
        {{ 'app.identity.disclosure.page.retry' | translate }}
      </app-parent-button>
    </app-parent-empty-state>
  } @else if (grants().length === 0) {
    <app-parent-empty-state
      [centered]="false"
      titleKey="app.identity.disclosure.grants.empty"
      subtitleKey="app.identity.disclosure.grants.emptyHint"
      ariaLabelKey="app.identity.disclosure.grants.emptyAria"
      iconMask="/public/svgs/bell.svg"
    />
  } @else {
    <div class="disclosure-grants__list">
      @for (grant of grants(); track grant.id) {
        <article class="disclosure-grant-card">
          <header class="disclosure-grant-card__header">
            <div>
              <h2 class="disclosure-grant-card__title">
                {{
                  kidName(grant.subjectUserId) ||
                    ('app.identity.disclosure.request.unknownChild' | translate)
                }}
              </h2>
              <p class="disclosure-grant-card__meta">
                {{ 'app.identity.disclosure.request.partner' | translate }}:
                <strong>{{ partnerLabel(grant.partnerRef) }}</strong>
              </p>
            </div>
            @if (expiryDate(grant); as expires) {
              <p class="disclosure-grant-card__expiry">
                {{ 'app.identity.disclosure.grants.expires' | translate }}:
                {{ expires | date: 'mediumDate' }}
              </p>
            }
          </header>

          @if (grantedDate(grant); as granted) {
            <p class="disclosure-grant-card__granted">
              {{ 'app.identity.disclosure.grants.granted' | translate }}:
              {{ granted | date: 'mediumDate' }}
            </p>
          }

          <section class="disclosure-grant-card__scopes">
            <span class="disclosure-grant-card__scopes-label">
              {{ 'app.identity.disclosure.grants.sharedData' | translate }}
            </span>
            <ul class="disclosure-grant-card__scope-list">
              @for (scopeId of grant.scopeIds ?? []; track scopeId) {
                <li>{{ scopeLabel(scopeId) }}</li>
              }
            </ul>
          </section>

          <footer class="disclosure-grant-card__actions">
            <app-parent-button
              variant="ghost"
              [loading]="isActing(grant.id!)"
              [disabled]="isActing(grant.id!)"
              (clicked)="revoke(grant)"
            >
              {{ 'app.identity.disclosure.grants.revoke' | translate }}
            </app-parent-button>
          </footer>
        </article>
      }
    </div>
  }
</div>
